import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { NOTE_SUBJECT_TO_MARKET_RISK } from "../../../constants";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";
import { mapping } from "../../../defaultValues/product";
import { extractPolicyTermFromMapper } from "../../../helpers/product";

const CURRENCY_FORMAT = {
  maximumFractionDigits: 0,
  style: "currency",
  currency: "INR",
};

const ResultSummary = ({
  classes: { formGroup, summaryText },
  form = {},
  selectedProduct,
  quotation = {},
}) => {
  // const premium = Number(form?.premium ?? 0);
  const premium = Number(quotation?.premiumIncludingGst ?? 0);
  const paymentFrequency = form?.paymentFrequency?.toLowerCase?.() ?? "";
  const ppt = form?.ppt ?? "";
  const maturityBonus = Number(quotation?.maturityTerminalBonus1 ?? 0);
  const asterisk = quotation?.asterisk ?? false;
  const policyTerm = extractPolicyTermFromMapper?.(selectedProduct, form) ?? "";

  const formattedPremium = premium.toLocaleString("en-IN", CURRENCY_FORMAT);
  const formattedMaturityBonus = maturityBonus.toLocaleString(
    "en-IN",
    CURRENCY_FORMAT
  );

  let summary;
  if (form?.productConfig) {
    summary = (
      <Typography variant="caption" color="white">
        Pay as low as {formattedPremium} {paymentFrequency} to avail Life Cover
        of {formattedMaturityBonus} lacs.
      </Typography>
    );
  } else {
    const totalPremium = Number(
      premium * (mapping?.paymentFrequency?.[form?.paymentFrequency] ?? 1)
    );
    const formattedTotalPremium = totalPremium.toLocaleString(
      "en-IN",
      CURRENCY_FORMAT
    );

    summary = (
      <Typography variant="caption" color="white">
        Invest {formattedTotalPremium} {paymentFrequency} for {ppt} years, and
        get {formattedMaturityBonus}
        {asterisk ? "*" : ""} after {policyTerm} years.
      </Typography>
    );
  }

  return (
    <Box
      className={formGroup}
      textAlign="left"
      justifyContent="flex-start"
      pb={0}
    >
      <Box className={summaryText}>{summary}</Box>
      {asterisk && (
        <Box textAlign="left" mt={0}>
          <Typography variant="caption">
            <small>{NOTE_SUBJECT_TO_MARKET_RISK}</small>
          </Typography>
        </Box>
      )}
    </Box>
  );
};

ResultSummary.propTypes = {
  classes: PropTypes.shape({
    formGroup: PropTypes.string,
    summaryText: PropTypes.string,
  }).isRequired,
  form: PropTypes.object,
  selectedProduct: PropTypes.any,
  quotation: PropTypes.object,
};

export default withStyles(useStyles, { withTheme: true })(ResultSummary);
